<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Bank {{ (bank.name) ? (" - " + bank.name) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Bank - {{bank.name}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="bank.code" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="bank.name" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="bank.remark" />
                </base-input>
                <hr><h4>Bank Checklist</h4>
                <base-checkbox class="mb-3" v-model="checkboxes.isCreditCardAcquiring">
                    Credit Card Accquiring Bank
                </base-checkbox>
                <base-checkbox class="mb-3" v-model="checkboxes.isEpsAcquiring">
                    EPS Accquiring Bank
                </base-checkbox>
            </div>
            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="bank" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="bank.code" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="bank.name" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="bank.remark" />
                        </base-input>
                        <hr><h4>Bank Checklist</h4>
                        <base-checkbox class="mb-3" v-model="checkboxes.isCreditCardAcquiring">
                            Credit Card Accquiring Bank
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEpsAcquiring">
                            EPS Accquiring Bank
                        </base-checkbox>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="bank" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <br><br>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
            <!-- <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
            </div> -->
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'

    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Bank?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0) {
                var bank_data = await HTTPRequest.getRequest(component_x.endPoint + 'banks/' + component_x.profileId, null)
                if (bank_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (bank_data["error"] == undefined) {
                        component_x.bank = bank_data
                        component_x.inputName = bank_data["name"]
                        component_x.inputCode = bank_data["code"]
                        component_x.inputRemark = bank_data["remark"]
                        component_x.checkboxes.isCreditCardAcquiring = bank_data["is_credit_card_acquiring"]
                        component_x.checkboxes.isEpsAcquiring = bank_data["is_eps_acquiring"]
                    } else {
                        this.errors = bank_data["error"].split(",")
                    }
                }
            }

            // To handle update on dynamic forms on load
            this.dynamicFormKey++;
        },
        data: function () {
            return {
                checkboxes: {
                    isCreditCardAcquiring: false,
                    isEpsAcquiring: false
                },
                errors: [],

                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                bank: {
                    code: '',
                    name: ''
                },
                formErrors: []
            }
        },
        methods: {
            // meta-data functions
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bank
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.bank = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.bank.code));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.bank.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.bank.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.bank.name));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.bank.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.bank.name, 0, 50));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var bankPayload = {
                    //     bank: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         is_credit_card_acquiring: this.checkboxes.isCreditCardAcquiring,
                    //         is_eps_acquiring: this.checkboxes.isEpsAcquiring
                    //     }
                    // }
                    this.bank.name = this.bank.name.trim()
                    this.bank.code = this.bank.code.trim()
                    this.bank.status = 'A'
                    this.bank.is_credit_card_acquiring = this.checkboxes.isCreditCardAcquiring,
                    this.bank.is_eps_acquiring = this.checkboxes.isEpsAcquiring
                    var bankPayload = { bank: this.bank }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'banks', null, bankPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var bankPayload = {
                    //     bank: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         is_credit_card_acquiring: this.checkboxes.isCreditCardAcquiring,
                    //         is_eps_acquiring: this.checkboxes.isEpsAcquiring
                    //     }
                    // }
                    this.bank.name = this.bank.name.trim()
                    this.bank.code = this.bank.code.trim()
                    let status = (this.bank.status == null) ?  "A" : this.bank.status
                    this.bank.status = status
                    // this.bank.status = 'A'
                    this.bank.is_credit_card_acquiring = this.checkboxes.isCreditCardAcquiring,
                    this.bank.is_eps_acquiring = this.checkboxes.isEpsAcquiring
                    var bankPayload = { bank: this.bank }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'banks/' + this.profileId, null, bankPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>